/**
 * Calculate totals from detail rows
 */
export const calculateTotals = (detailRows: BanHangRecord[] = []) => {
  const totalPSNo = detailRows.reduce((sum: number, row: { ps_no_nt: number }) => sum + (row.ps_no_nt || 0), 0);
  const totalPSCo = detailRows.reduce((sum: number, row: { ps_co_nt: number }) => sum + (row.ps_co_nt || 0), 0);

  return {
    totalPSNo,
    totalPSCo
  };
};

export const handleUpdateRowFields = (row: BanHangRecord, field: string, newValue: BanHangValue) => {
  if (field === 'ps_no_nt') {
    return {
      ps_no_nt: newValue,
      ps_co_nt: 0
    };
  }
  if (field === 'ps_co_nt') {
    return {
      ps_no_nt: 0,
      ps_co_nt: newValue
    };
  }

  return {};
};
